import {
  ADD_TO_CART,
  DECREMENT_QUANTITY,
  DELETE_CART,
  INCREMENT_QUANTITY,
} from "./actionType";

export const addToCart = (value) => {
  return {
    type: ADD_TO_CART,
    payload: value,
  };
};

export const deleteCart = (cartId) => {
  return {
    type: DELETE_CART,
    payload: cartId,
  };
};

export const incrementQuantity = (productId) => ({
  type: INCREMENT_QUANTITY,
  payload: productId,
});

export const decrementQuantity = (productId) => ({
  type: DECREMENT_QUANTITY,
  payload: productId,
});
